exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hedaer-container {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  height: 315px;\n  margin: 0;\n  background: #fff;\n  border-bottom: 5px solid #F7A500;\n  position: relative; }\n\n.logo-image-container {\n  height: 54%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: end;\n      align-items: flex-end; }\n\n.logo-text-container {\n  position: relative;\n  padding: 0px 0px 0px 0px;\n  margin: 0 auto;\n  font-size: calc(10px + 1.5vw);\n  font-weight: 300;\n  color: #6D6D6D;\n  display: -ms-flexbox;\n  display: flex;\n  height: 50%;\n  -ms-flex-align: center;\n      align-items: center; }\n\n.image {\n  height: auto;\n  width: 100%;\n  min-height: 73px;\n  min-width: 245px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/logo-header/logo-header.component.scss
// module id = ../../../../../src/app/core/components/logo-header/logo-header.component.scss
// module chunks = main